var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.header.useIcons)?_c('v-icon',{attrs:{"color":_vm.color},domProps:{"textContent":_vm._s(_vm.icon)}}):_c('span',{domProps:{"textContent":_vm._s(_vm.label)}})
}
var staticRenderFns = []

export { render, staticRenderFns }